// Global plugin formats supported by all AVX Pro products.
export const AVX_FORMATS = ["VST3", "AU", "AAX"];

export function formatCLP(value) {
    if (value == null || value === 0) return "—";
    try {
        return new Intl.NumberFormat("es-CL", {
            style: "currency",
            currency: "CLP",
            maximumFractionDigits: 0,
        }).format(value);
    } catch {
        return `$${value}`;
    }
}

/**
 * Determine if a product has an active sale (sale_price > 0 and < base price)
 * and compute the discount percentage. Returns null if no sale.
 */
export function computeSale(product) {
    if (!product) return null;
    const base = Number(product.price_clp || 0);
    const sale = Number(product.sale_price_clp || 0);
    if (sale > 0 && base > 0 && sale < base) {
        const pct = Math.round(((base - sale) / base) * 100);
        return {
            onSale: true,
            base_clp: base,
            sale_clp: sale,
            base_usd: Number(product.price_usd || 0),
            sale_usd: Number(product.sale_price_usd || 0) || Number(product.price_usd || 0),
            discount_pct: pct,
        };
    }
    return null;
}

export function formatUSD(value) {
    if (value == null || value === 0) return "—";
    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(value);
    } catch {
        return `US$${value}`;
    }
}

export function formatDate(value) {
    if (!value) return "—";
    try {
        const d = new Date(value);
        return d.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return String(value);
    }
}

export function formatDateTime(value) {
    if (!value) return "—";
    try {
        const d = new Date(value);
        return d.toLocaleString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return String(value);
    }
}

export function formatBytes(bytes) {
    if (!bytes && bytes !== 0) return "—";
    const units = ["B", "KB", "MB", "GB"];
    let i = 0;
    let v = Number(bytes);
    while (v >= 1024 && i < units.length - 1) {
        v /= 1024;
        i++;
    }
    return `${v.toFixed(v < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

export function resolveImageUrl(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) {
        return `${process.env.REACT_APP_BACKEND_URL}${url}`;
    }
    return url;
}
